
































import Vue from "vue";

import AliasChangeModal from "@tt-app/components/user/settings/AliasChangeModal.vue";

import IconLogout from "@joyz/app-core/assets/icons/default/LogOut.svg";

interface Data {
  aliasChange: {
    open: boolean;
  };
}

interface Methods {
  handleAliasChangeClick: () => void;
  handleAliasChangeClose: () => void;
}

interface Computed {
  aliasChangeLinkVisible: boolean;
}

interface Props {
  email: string;
  organisation: string;
  iconLogout: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SettingsHeader",

  components: { AliasChangeModal },

  props: {
    email: { type: String, default: "" },
    organisation: { type: String, default: "" },
    iconLogout: { type: String, default: IconLogout }
  },

  data() {
    return {
      aliasChange: {
        open: false
      }
    };
  },

  methods: {
    handleAliasChangeClick() {
      this.aliasChange.open = true;
    },

    handleAliasChangeClose() {
      this.aliasChange.open = false;
    }
  },

  computed: {
    aliasChangeLinkVisible() {
      if (!this.$store.state.user.aliases?.length) return false;

      return this.$store.state.user.aliases.length > 1;
    }
  }
});
